import React, { useState } from 'react';
import { Menu, Bell, Search, ChevronDown, User } from 'lucide-react';
import { useAuth } from '../../../middleware/authMiddleware'; // Adjust path as needed

const Navbar = ({ toggleSidebar }) => {
  const { user } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);

  return (
    <div className="bg-white shadow-md h-16 flex items-center justify-between px-4 md:px-6">
      {/* Left section - Mobile menu toggle and search */}
      <div className="flex items-center">
        <button 
          onClick={toggleSidebar} 
          className="mr-4 lg:hidden text-gray-700 hover:text-gray-900"
        >
          <Menu size={24} />
        </button>
        <div className="relative hidden md:block">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <Search size={18} className="text-gray-400" />
          </div>
          <input
            type="search"
            className="block w-64 p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Search..."
          />
        </div>
      </div>

      {/* Right section - Notifications and user profile */}
      <div className="flex items-center space-x-4">
        {/* Notifications */}
        <div className="relative">
          <button 
            className="text-gray-700 hover:text-gray-900 relative"
            onClick={() => setShowNotifications(!showNotifications)}
          >
            <Bell size={20} />
            <span className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-4 h-4 text-xs flex items-center justify-center">
              3
            </span>
          </button>

          {/* Notification dropdown */}
          {showNotifications && (
            <div className="absolute right-0 mt-2 w-80 bg-white rounded-md shadow-lg z-20">
              <div className="p-3 border-b border-gray-200">
                <h3 className="text-sm font-semibold">Notifications</h3>
              </div>
              <div className="max-h-64 overflow-y-auto">
                <div className="px-4 py-3 border-b border-gray-200 hover:bg-gray-50">
                  <p className="text-sm">New user registration: John Smith</p>
                  <p className="text-xs text-gray-500">10 minutes ago</p>
                </div>
                <div className="px-4 py-3 border-b border-gray-200 hover:bg-gray-50">
                  <p className="text-sm">System update scheduled</p>
                  <p className="text-xs text-gray-500">1 hour ago</p>
                </div>
                <div className="px-4 py-3 hover:bg-gray-50">
                  <p className="text-sm">New announcement published</p>
                  <p className="text-xs text-gray-500">2 hours ago</p>
                </div>
              </div>
              <div className="p-2 text-center border-t border-gray-200">
                <button className="text-sm text-blue-600 hover:text-blue-800">
                  View all notifications
                </button>
              </div>
            </div>
          )}
        </div>

        {/* User profile */}
        <div className="relative">
          <button 
            className="flex items-center space-x-2 text-gray-700 hover:text-gray-900"
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white">
              <User size={18} />
            </div>
            <span className="hidden md:block text-sm font-medium">
              {user?.name || 'Admin User'}
            </span>
            <ChevronDown size={16} />
          </button>

          {/* User dropdown menu */}
          {showUserMenu && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-20">
              <div className="py-1">
                <a href="/admin/profile" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                  Your Profile
                </a>
                <a href="/admin/settings" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                  Settings
                </a>
                <button onClick={() => window.location.href = '/admin/login'} className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100">
                  Sign out
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;